// components/ProgressGlowBar.jsx
import React from 'react';
import './ProgressGlowBar.css';

const ProgressGlowBar = ({ currentStep, totalSteps }) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <div className="progress-container">
      {steps.map((step, i) => (
        <div key={step} className="step-wrapper">
          <div
            className={`circle ${currentStep > step ? 'completed' : ''} ${currentStep === step ? 'active' : ''}`}
          >
            {currentStep > step ? '✓' : step}
          </div>
          {i < totalSteps - 1 && (
            <div className={`bar ${currentStep > step ? 'filled' : ''}`} />
          )}
        </div>
      ))}
    </div>
  );
};

export default ProgressGlowBar;
